import React from 'react'

export interface CategoryIconProps {
  selected?: boolean
  className?: string
}

interface CategorySvgIconProps extends CategoryIconProps {
  baseName: string
  imageBasePath?: string
}

export const CategorySvgIcon: React.FC<CategorySvgIconProps> = ({
  baseName,
  selected,
  className,
  imageBasePath = '/svg'
}) => {
  const fileName = selected ? `${baseName}_filled.svg` : `${baseName}.svg`
  const imagePath = `${imageBasePath}/${fileName}`
  return <img src={imagePath} alt={baseName} className={className} />
}

export const LargeCapCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='large_cap' {...props} />
)

export const MidCapCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='mid_cap' {...props} />
)

export const SmallCapCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='small_cap' {...props} />
)

export const FlexiCapCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='flexi_cap' {...props} />
)

export const LargeAndMidCapCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='large_and_mid_cap' {...props} />
)

export const MultiCapCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='multi_cap' {...props} />
)

export const ValueAndContraCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='value_and_contra' {...props} />
)

export const FocusedFundCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='focused_fund' {...props} />
)

export const ELSSCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='elss_tax_savings' {...props} />
)

// Sectoral/Thematic icons
export const SectorConsumptionCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='consumption' {...props} />
)

export const SectorESGCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='esg' {...props} />
)

export const SectorFinancialServicesCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='financial_services' {...props} />
)

export const SectorHealthcareCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='healthcare' {...props} />
)

export const SectorInfrastructureCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='infrastructure' {...props} />
)

export const SectorQuantCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='quant' {...props} />
)

export const SectorTechnologyCategoryIcon: React.FC<CategoryIconProps> = (props) => (
  <CategorySvgIcon baseName='technology' {...props} />
)
